import type { Catalog, RecipeDocument } from "@/lib/types";

/**
 * Thin client over the static /data/ JSON the catalog builder emits.
 * Centralizes fetch + cache so feature code stays simple.
 */

let catalogCache: Promise<Catalog> | null = null;
const recipeCache = new Map<string, Promise<RecipeDocument>>();

export function getCatalog(): Promise<Catalog> {
  if (!catalogCache) {
    catalogCache = fetch("/data/catalog.json").then((r) => {
      if (!r.ok) throw new Error(`catalog.json: ${r.status}`);
      return r.json();
    });
  }
  return catalogCache;
}

export function getRecipe(id: string): Promise<RecipeDocument> {
  let p = recipeCache.get(id);
  if (!p) {
    p = fetch(`/data/recipes/${id}.json`).then((r) => {
      if (!r.ok) throw new Error(`${id}.json: ${r.status}`);
      return r.json();
    });
    recipeCache.set(id, p);
  }
  return p;
}

/** Test-only: clears caches. */
export function _resetCatalogClient() {
  catalogCache = null;
  recipeCache.clear();
}
